/*eslint eqeqeq: "off"*/
import * as HmiFiles from './hmifiles';
import { windowCycleEvent } from './hmiglobal';

declare global {
    interface Window {}
}

interface TxtPos {
    text: string;
    index: number;
}

export async function AnimationMnemo(mnemodoc: any, win: any) {
    let dataLinkList = mnemodoc.getElementsByTagName('datalink');

    if (dataLinkList) {
        await LinkAnimation(mnemodoc, dataLinkList, win);
    }
}

async function AnimationSetValue(value: any, conditions: any, win: any, propertyName: any, animationObjW: any) {
    if (value != null && value != '') {
        if (value.indexOf('RUNONLY') !== -1) conditions.setAttribute('value', value.replace(/"RUNONLY"/g, 'false'));

        try {
            let rez: any = 0;

            let rezvalue = await EvalCommand(value, win, propertyName);
            value = rezvalue.v;

            if (conditions.childElementCount !== 0) {
                let transObj = conditions.firstElementChild;

                if (transObj.tagName.toLowerCase() === 'scale') {
                    let lowLimit = 0;
                    let highLimit = 100;
                    let moveFrom = 0;
                    let moveTo = 100;

                    rezvalue = await EvalCommand(transObj.getAttribute('lowlimit'), win, propertyName);
                    rez = rezvalue.v;

                    if (!isNaN(rez)) lowLimit = Number(rez);

                    rezvalue = await EvalCommand(transObj.getAttribute('highlimit'), win, propertyName);
                    rez = rezvalue.v;
                    if (!isNaN(rez)) highLimit = Number(rez);

                    rezvalue = await EvalCommand(transObj.getAttribute('movefrom'), win, propertyName);
                    rez = rezvalue.v;
                    if (!isNaN(rez)) moveFrom = Number(rez);

                    rezvalue = await EvalCommand(transObj.getAttribute('moveto'), win, propertyName);
                    rez = rezvalue.v;
                    if (!isNaN(rez)) moveTo = Number(rez);

                    value = ((moveTo - moveFrom) * (value - lowLimit)) / (highLimit - lowLimit) + moveFrom;
                    if (value < Math.min(moveFrom, moveTo)) {
                        value = Math.min(moveFrom, moveTo);
                    } else if (value > Math.max(moveFrom, moveTo)) {
                        value = Math.max(moveFrom, moveTo);
                    }
                } else if (transObj.tagName.toLowerCase() === 'table') {
                    let rows = transObj.getElementsByTagName('row');
                    if (typeof value === 'boolean') value = Number(value);

                    let truerow = -1;

                    for (let irow = 0; irow < rows.length; irow++) {
                        if (typeof value === 'number') {
                            let lowLimit: number | undefined = undefined;
                            let highLimit: number | undefined = undefined;

                            rezvalue = await EvalCommand(rows[irow].getAttribute('highlimit'), win, propertyName);
                            rez = rezvalue.v;
                            if (!isNaN(rez)) highLimit = Number(rez);

                            rezvalue = await EvalCommand(rows[irow].getAttribute('lowlimit'), win, propertyName);
                            rez = rezvalue.v;
                            if (!isNaN(rez)) lowLimit = Number(rez);

                            if (highLimit == undefined || lowLimit == undefined) {
                                continue;
                            }

                            if (lowLimit <= value && value <= highLimit) {
                                rezvalue = await EvalCommand(rows[irow].getAttribute('value'), win, propertyName);
                                value = rezvalue.v;

                                truerow = irow;

                                break;
                            } else if (irow === rows.length - 1) {
                                value = 'default';
                            }
                        } else {
                            let lowLimit: any = null;
                            let highLimit: any = null;

                            rezvalue = await EvalCommand(rows[irow].getAttribute('highlimit'), win, propertyName);
                            highLimit = rezvalue.v;

                            rezvalue = await EvalCommand(rows[irow].getAttribute('lowlimit'), win, propertyName);
                            lowLimit = rezvalue.v;

                            if (highLimit == undefined || lowLimit == undefined) {
                                continue;
                            }

                            if (lowLimit.toString() == value.toString() && value.toString() == highLimit.toString()) {
                                rezvalue = await EvalCommand(rows[irow].getAttribute('value'), win, propertyName);
                                value = rezvalue.v;
                                truerow = irow;
                                break;
                            } else if (irow === rows.length - 1) {
                                value = 'default';
                            }
                        }
                    }

                    if (truerow == -1) value = 'default';
                    let propertyNameBlink = propertyName;

                    let styleprop = animationObjW.style;
                    if (styleprop[propertyNameBlink] === undefined) {
                        for (let prop in styleprop) {
                            if (prop.toLowerCase() == propertyNameBlink) {
                                propertyNameBlink = prop;
                                break;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            value = 'default';
        }
    } else {
        value = 'default';
    }
    return value;
}

async function LinkAnimation(mnemodoc: any, dataLinks: any, win: any) {
    let animationObjW: any = {};
    if (dataLinks) {
        for (let ilink = dataLinks.length; ilink--; ) {
            try {
                animationObjW = mnemodoc.querySelector(
                    "[data-datalinklistid='" + dataLinks[ilink].parentNode.id + "']"
                );

                if (animationObjW) {
                    win['animationObjW'] = animationObjW;

                    let propertyName = dataLinks[ilink].getAttribute('propertyname');

                    if (animationObjW.namespaceURI !== 'http://www.w3.org/2000/svg') {
                        let attrtype = animationObjW.getAttribute('type');
                        if (attrtype === 'button' || attrtype === 'submit') {
                            propertyName = propertyName.toLowerCase() === 'fill' ? 'background' : propertyName;
                        } else {
                            propertyName = propertyName.toLowerCase() === 'fill' ? 'color' : propertyName;
                        }
                        propertyName = propertyName.toLowerCase() === 'stroke' ? 'border' : propertyName;
                    }

                    let propertyNameBlink = propertyName.toLowerCase();
                    let blinkstate = false;
                    let blincValue = '';
                    let propertyValue: any = undefined;

                    let conditions = dataLinks[ilink].getElementsByTagName('condition')[0];

                    propertyName = propertyName.toLowerCase();

                    if (conditions) {
                        if (!conditions.hasAttribute('value')) {
                            continue;
                        }

                        let value = conditions.getAttribute('value');

                        let repeat = true;
                        if (conditions.hasAttribute('repeat')) {
                            let repeatatr = conditions.getAttribute('repeat');
                            repeat = repeatatr == 'true' ? true : false;

                            if (!repeat) {
                                conditions.removeAttribute('value');
                            }
                        }

                        propertyValue = await AnimationSetValue(value, conditions, win, propertyName, animationObjW);
                    } else {
                        propertyValue = 'default';
                    }

                    // let animation = dataLinks[ilink].querySelector("animation");
                    let animation = dataLinks[ilink].getElementsByTagName('animation')[0];

                    if (animation != null) {
                        let blinkStateCondition = animation
                            .getElementsByTagName('blinkstate')[0]
                            .getElementsByTagName('condition')[0];
                        let blinkValueCondition = animation
                            .getElementsByTagName('blinkvalue')[0]
                            .getElementsByTagName('condition')[0];

                        if (blinkStateCondition != null && blinkValueCondition != null) {
                            let state = blinkStateCondition.getAttribute('value');
                            let blinkstateObj = await AnimationSetValue(
                                state,
                                blinkStateCondition,
                                win,
                                propertyName,
                                animationObjW
                            );
                            blinkstate = blinkstateObj == 'NaN' ? false : blinkstateObj;

                            let value = blinkValueCondition.getAttribute('value');
                            blincValue = await AnimationSetValue(
                                value,
                                blinkValueCondition,
                                win,
                                propertyName,
                                animationObjW
                            );
                        }
                    }

                    let defaultAnim: any = {};
                    if (!animationObjW.hasAttribute('data-defaultAnim')) {
                        defaultAnim.content =
                            animationObjW.tagName.toLowerCase() === 'text' ||
                            animationObjW.tagName.toLowerCase() === 'p'
                                ? animationObjW.textContent
                                : animationObjW.getAttribute('value');
                        defaultAnim.fill = animationObjW.style.fill === undefined ? '#000' : animationObjW.style.fill;
                        defaultAnim.stroke =
                            animationObjW.style.stroke === undefined ? '#000' : animationObjW.style.stroke;
                        defaultAnim.left = 0;
                        defaultAnim.top = 0;
                        defaultAnim.rotation = 0;

                        defaultAnim.opacity = animationObjW.style.opacity;
                        defaultAnim.fillopacity = animationObjW.style.fillOpacity;
                        defaultAnim.strokeopacity = animationObjW.style.strokeOpacity;

                        defaultAnim.background =
                            animationObjW.style.background === undefined ? '' : animationObjW.style.background;
                        defaultAnim.color = animationObjW.style.color === undefined ? '' : animationObjW.style.color;

                        if (animationObjW.getAttribute('title'))
                            defaultAnim.title = animationObjW.getAttribute('title');

                        if (animationObjW.parentNode.tagName == 'foreignObject') {
                            defaultAnim.visibility = animationObjW.parentNode.style.visibility;

                            if (animationObjW.parentNode.height !== undefined) {
                                defaultAnim.height =
                                    animationObjW.parentNode.height.baseVal !== undefined
                                        ? animationObjW.parentNode.height.baseVal.value
                                        : animationObjW.parentNode.height;
                            } else {
                                defaultAnim.height = '';
                            }

                            if (animationObjW.parentNode.width !== undefined) {
                                defaultAnim.width =
                                    animationObjW.parentNode.width.baseVal !== undefined
                                        ? animationObjW.parentNode.width.baseVal.value
                                        : animationObjW.parentNode.width;
                            } else {
                                animationObjW.parentNode.width = '';
                            }
                        } else {
                            defaultAnim.visibility = animationObjW.style.visibility;

                            if (animationObjW.height !== undefined) {
                                defaultAnim.height =
                                    animationObjW.height.baseVal !== undefined
                                        ? animationObjW.height.baseVal.value
                                        : animationObjW.height;
                            } else {
                                defaultAnim.height = '';
                            }

                            if (animationObjW.width !== undefined) {
                                defaultAnim.width =
                                    animationObjW.width.baseVal !== undefined
                                        ? animationObjW.width.baseVal.value
                                        : animationObjW.width;
                            } else {
                                defaultAnim.width = '';
                            }
                        }

                        let animString = JSON.stringify(defaultAnim);
                        animationObjW.setAttribute('data-defaultAnim', animString);
                    }

                    if (propertyValue === 'default' && animationObjW.hasAttribute('data-defaultAnim')) {
                        let animString = animationObjW.getAttribute('data-defaultAnim');
                        let defaultAnim = JSON.parse(animString);
                        propertyValue = defaultAnim[propertyName.toLowerCase()];
                    }

                    if (!blinkstate) {
                        let oldblink = animationObjW.hasAttribute('flicker-condition')
                            ? JSON.parse(animationObjW.getAttribute('flicker-condition'))
                            : {};
                        if (oldblink[propertyNameBlink] !== undefined) {
                            oldblink[propertyNameBlink].enable = false;
                            oldblink[propertyNameBlink].normValue = propertyValue;
                            animationObjW.setAttribute('flicker-condition', JSON.stringify(oldblink));
                        }
                    } else {
                        let oldblink = animationObjW.hasAttribute('flicker-condition')
                            ? JSON.parse(animationObjW.getAttribute('flicker-condition'))
                            : {};
                        if (oldblink[propertyNameBlink] === undefined) {
                            oldblink[propertyNameBlink] = {};
                            oldblink[propertyNameBlink].enable = false;
                        }

                        if (
                            oldblink[propertyNameBlink].value !== blincValue ||
                            oldblink[propertyNameBlink].enable !== true
                        ) {
                            oldblink[propertyNameBlink].value = blincValue;
                            oldblink[propertyNameBlink].enable = true;
                            oldblink[propertyNameBlink].normValue = propertyValue;
                            animationObjW.setAttribute('flicker-condition', JSON.stringify(oldblink));
                        }
                    }

                    let curdata = animationObjW['previousvalues'];
                    if (curdata == null) {
                        animationObjW['previousvalues'] = {};
                        curdata = animationObjW['previousvalues'];
                    }

                    if (curdata[propertyName] !== propertyValue) {
                        curdata[propertyName] = propertyValue;

                        AnimationFnc(win, mnemodoc, animationObjW, propertyName, propertyValue);
                    }
                }
            } catch (err) {}
        }
    }
}

function TextToTSPAN(obj: any, value: string) {
    value = value || '';
    let whdef = 100000;
    let width = whdef;
    let height = whdef;
    let FONT_SIZE = 14;
    let FONT_FAMILY = 'Courier New';
    let lineheight = 1;

    let atributes: any[] = [];

    if (obj.hasAttribute('style')) atributes = obj.getAttribute('style').replace(' ', '').split(';');

    for (let countattr = 0; countattr < atributes.length; countattr++) {
        atributes[countattr] = atributes[countattr].replace(/\s+/g, '');
        if (atributes[countattr].indexOf('font-family:') === 0) {
            FONT_FAMILY = atributes[countattr].trim().replace('font-family:', '');
        } else if (atributes[countattr].indexOf('font-size:') === 0) {
            FONT_SIZE = Number(atributes[countattr].match(/[0-9]+(?:\.[0-9]*)?/i)[0]);
        } else if (atributes[countattr].indexOf('width:') === 0) {
            width = Number(atributes[countattr].match(/[0-9]+(?:\.[0-9]*)?/i)[0]);
        } else if (atributes[countattr].indexOf('height:') === 0) {
            height = Number(atributes[countattr].match(/[0-9]+(?:\.[0-9]*)?/i)[0]);
        } else if (atributes[countattr].indexOf('line-height:') === 0) {
            lineheight = Number(atributes[countattr].match(/[0-9]+(?:\.[0-9]*)?/i)[0]);
        }
    }

    if (width === whdef)
        if (obj.hasAttribute('width')) width = Number(obj.getAttribute('width').match(/[0-9]+(?:\.[0-9]*)?/i)[0]);

    if (height === whdef)
        if (obj.hasAttribute('height')) height = Number(obj.getAttribute('height').match(/[0-9]+(?:\.[0-9]*)?/i)[0]);

    value = value.toString().replace(/|\s{2,}/gi, '');

    let x: any = 0;
    let y: any = 0;

    let children = obj.getElementsByTagName('tspan');
    if (children.length !== 0) {
        if (children[0].hasAttribute('x')) x = children[0].getAttribute('x');
        if (children[0].hasAttribute('y')) y = children[0].getAttribute('y');
    } else {
        if (obj.hasAttribute('x')) x = obj.getAttribute('x');
        if (obj.hasAttribute('y')) y = obj.getAttribute('y');
    }

    let tspanelem2: any = children[0];

    if (tspanelem2 == null) {
        tspanelem2 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        tspanelem2.setAttribute('x', x);
        tspanelem2.setAttribute('y', y);
        tspanelem2.style.display = 'block';
        obj.appendChild(tspanelem2);
    }

    if (width == whdef && height == whdef) {
        for (let ii = 1; ii < children.length; ii++) {
            obj.removeChild(children[ii]);
        }

        tspanelem2.textContent = value;
    } else {
        for (let ii = 1; ii < children.length; ii++) {
            obj.removeChild(children[ii]);
        }

        let buk = '';

        let child: any[] = [];
        tspanelem2.textContent = '';

        let wordBreak = obj.style.wordBreak ? obj.style.wordBreak.toLowerCase() : 'normal';
        let padding = 0;

        for (let i = 0; i < value.length; i++) {
            buk = value[i];
            tspanelem2.textContent = tspanelem2.textContent + buk;
            if (tspanelem2.getComputedTextLength() > width - 2 * padding && tspanelem2.textContent.length > 0) {
                //продумать алгоритм точного вычисления значения

                let indspace = -1;
                if (wordBreak == 'normal') {
                    if (buk !== ' ') {
                        indspace = tspanelem2.textContent.lastIndexOf(' ');
                    }
                } else {
                    ///break-all
                    indspace = tspanelem2.textContent.length - 2;
                }

                if (indspace != -1) {
                    i = i - (tspanelem2.textContent.length - indspace) + 1;
                    tspanelem2.textContent = tspanelem2.textContent.slice(
                        0,
                        -(tspanelem2.textContent.length - indspace - 1)
                    );
                }

                tspanelem2.style.display = 'none';
                child.push(tspanelem2);

                tspanelem2 = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                y = Number(y) + (Number(FONT_SIZE) + 1.5) * lineheight;
                if (Number(y) > Number(height)) {
                    break;
                }
                tspanelem2.setAttribute('x', x);
                tspanelem2.setAttribute('y', y.toString());
                obj.appendChild(tspanelem2);
            }
        }

        for (let i = 0; i < child.length; i++) {
            child[i].style.display = 'block';
        }
    }

    return obj;
}

function GetActiveDocument(doc: any) {
    let activ = doc.activeElement;
    if (activ) {
        if (activ.nodeName.toUpperCase() === 'IFRAME') {
            activ = GetActiveDocument(activ.contentDocument);
        }
    }
    return activ;
}

function GetRGB(value: any): string {
    if (value.toString().indexOf('#') === -1 && value.toString().indexOf('rgb') === -1 && !isNaN(value)) {
        value = Number(value);
        let blue = (value & 0xff) >> 0;
        let gree = (value & 0xff00) >> 8;
        let red = (value & 0xff0000) >> 16;
        let alpha = (value & 0xff000000) >> 24;
        value = 'rgb(' + blue + ',' + gree + ',' + red + ')';
    }
    value = value.replace(/'/g, '');
    return value;
}

export function Decimals(propertyValue: any, decimals: any) {
    if (decimals >= 0) {
        propertyValue = propertyValue.toFixed(decimals);
    }
    return propertyValue;
}

export function Numberdigital(propertyValue: any, numberdigital: any) {
    if (numberdigital > 0) {
        let propertyValueStr = propertyValue.toString();
        if (numberdigital < propertyValueStr.length && (propertyValue ^ 0) !== propertyValue) {
            if (numberdigital > propertyValueStr.indexOf('.') && !propertyValueStr.includes('e')) {
                let decimals = numberdigital - propertyValueStr.indexOf('.');
                propertyValue = Number(propertyValue).toFixed(decimals);
            } else {
                if (!propertyValueStr.includes('e')) {
                    propertyValueStr = propertyValue.toPrecision(numberdigital);
                }

                let expmax = numberdigital - (propertyValueStr.length - propertyValueStr.indexOf('e') + 1);

                propertyValue = Number(propertyValue).toExponential(expmax);
            }
        }
    }
    return propertyValue;
}

function AnimationFnc(win: any, mnemodoc: any, animationObj: any, propertyName: any, propertyValue: any) {
    let defaultValue;
    if (propertyName === 'content') {
        if (typeof propertyValue === 'number') {
            let decimals = 0;
            if (animationObj.hasAttribute('decimals')) {
                decimals = animationObj.getAttribute('decimals');

                //propertyValue = propertyValue.toString().includes("e") ? Number(propertyValue.toExponential(decimals)) : Number(propertyValue.toFixed(decimals));
                propertyValue = Decimals(propertyValue, decimals);
            }

            if (animationObj.hasAttribute('numberdigital')) {
                let numberdigital = Number(animationObj.getAttribute('numberdigital'));
                propertyValue = Numberdigital(propertyValue, numberdigital);
            }
        } else {
            if (animationObj.hasAttribute('numberdigital')) {
                let numberdigital = animationObj.getAttribute('numberdigital');
                if (numberdigital != '0') {
                    propertyValue = propertyValue.toString().slice(0, numberdigital);
                }
            }
        }

        if (animationObj.tagName.toLowerCase() === 'text') {
            TextToTSPAN(animationObj, propertyValue.toString());
        } else if (animationObj.tagName.toLowerCase() === 'input') {
            let updatestate = true;
            if (
                GetActiveDocument(win.document) === animationObj &&
                animationObj.getAttribute('type').toLowerCase() === 'text'
            ) {
                if (animationObj.hasAttribute('updatetime')) {
                    let olddate = animationObj.getAttribute('updatetime');
                    if (Number(olddate) + 15000 > Date.now()) {
                        updatestate = false;
                    }
                }
            } else if (animationObj.hasAttribute('updatetime')) {
                animationObj.removeAttribute('updatetime');
            }

            if (updatestate) {
                if (animationObj.type === 'checkbox' || animationObj.type === 'radio') {
                    propertyValue = !(
                        propertyValue === 'false' ||
                        propertyValue === '0.00' ||
                        propertyValue === null ||
                        propertyValue === false
                    );
                    animationObj.checked = propertyValue;
                } else {
                    animationObj.value = propertyValue;
                }

                if (
                    GetActiveDocument(win.document) === animationObj &&
                    animationObj.getAttribute('type').toLowerCase() === 'text'
                ) {
                    animationObj.focus();
                    animationObj.select();
                    animationObj.setAttribute('updatetime', Date.now());
                    //if (propertyValue !== "NaN") animationObj.setAttribute("updatetime", Date.now());
                }
            }
        } else if (animationObj.tagName.toLowerCase() === 'select') {
            animationObj.selectedIndex = propertyValue;
        } else if (animationObj.tagName.toLowerCase() === 'select') {
            animationObj.selectedIndex = propertyValue;
        } else if (animationObj.tagName.toLowerCase() === 'button') {
            let span = animationObj.querySelector('span');
            if (span == null) span = animationObj;
            span.innerHTML = propertyValue;
        } else {
            animationObj.innerText = propertyValue;
        }
    } else if (propertyName === 'decimal') {
        if (propertyValue != undefined) {
            animationObj.setAttribute(propertyName, propertyValue);
        } else {
            defaultValue = 2;
            SetDefaultValue(animationObj, propertyName, defaultValue);
        }
    } else if (
        propertyName === 'fill' ||
        propertyName === 'stroke' ||
        propertyName === 'color' ||
        propertyName === 'background'
    ) {
        if (propertyValue != undefined) {
            /*          
            let svgelem = animationObj.ownerSVGElement;
            if(svgelem) {
                let datalinklistElement = svgelem.getElementById(animationObj.dataset.datalinklistid);
                if(datalinklistElement) {
                    propertyName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
                    let datalink = datalinklistElement.querySelector(`[propertyname=${propertyName}]`);
                    let conditionElement = datalink.getElementsByTagName('condition')[0];
                    let сhildElement = conditionElement.firstElementChild;
        
                    if(сhildElement != null && сhildElement != undefined ) {
                        if (сhildElement.tagName.toLowerCase() === 'table') {
                            let rows = сhildElement.getElementsByTagName('row');
            
                            let colorFound = false;
            
                            for (let i = 0; i < rows.length; i++) {
                                let row = rows[i];
                                let lowLimit = Number(row.getAttribute('lowlimit'));
                                let highLimit = Number(row.getAttribute('highlimit'));
                                let value = row.getAttribute('value');
                            
                                if (propertyValue >= lowLimit && propertyValue <= highLimit) {
                                    propertyValue = value;
                                    colorFound = true;
                                    break;
                                }
                            }            
                        } 
                    }
                }
            }
*/

            if ((propertyName === 'fill' || propertyName === 'color') && animationObj.tagName == 'DIV') {
                propertyName = 'background';
            }

            if (
                propertyValue.toString().indexOf('#') !== -1 ||
                propertyValue.toString().indexOf('rgb') !== -1 ||
                !isNaN(propertyValue)
            ) {
                propertyValue = GetRGB(propertyValue);
            }

            if (propertyValue.indexOf('url') != -1 && animationObj.hasAttribute('data-defaultAnim')) {
                let animString = animationObj.getAttribute('data-defaultAnim');
                let defaultAnim = JSON.parse(animString);
                let defPropertyValue = defaultAnim[propertyName.toLowerCase()];
                if (defPropertyValue.includes('url')) {
                    if (animationObj.style[propertyName.toLowerCase()] != defPropertyValue) {
                        animationObj.style[propertyName.toLowerCase()] != defPropertyValue;
                    }
                }
            }

            if (!animationObj.style[propertyName.toLowerCase()].includes('url') || propertyValue.includes('url')) {
                if (animationObj.style[propertyName.toLowerCase()] != propertyValue) {
                    animationObj.style[propertyName.toLowerCase()] = propertyValue;
                }

                if (animationObj.style.markerStart != '') {
                    let idmarker = animationObj.style.markerStart
                        .replace('url(', '')
                        .replace(')', '')
                        .replace(/\"/g, '')
                        .replace('#', '');
                    let gradient = mnemodoc.getElementById(idmarker);
                    if (gradient !== null) {
                        gradient.firstElementChild.style.fill = propertyValue;
                        gradient.firstElementChild.style.stroke = propertyValue;
                    }
                }
                if (animationObj.style.markerEnd != '') {
                    let idmarker = animationObj.style.markerEnd
                        .replace('url(', '')
                        .replace(')', '')
                        .replace(/\"/g, '')
                        .replace('#', '');
                    let gradient = mnemodoc.getElementById(idmarker);
                    if (gradient !== null) {
                        gradient.firstElementChild.style.fill = propertyValue;
                        gradient.firstElementChild.style.stroke = propertyValue;
                    }
                }
            } else {
                if (animationObj.style[propertyName.toLowerCase()] != propertyValue) {
                    animationObj.style[propertyName.toLowerCase()] = propertyValue;
                }

                let idgrad = animationObj.style[propertyName.toLowerCase()]
                    .replace('url(', '')
                    .replace(')', '')
                    .replace(/\"/g, '')
                    .replace('#', '');
                let gradient = mnemodoc.getElementById(idgrad);
                if (gradient !== null) {
                    if (gradient.children[0] !== undefined)
                        gradient.children[0].setAttribute('stop-color', propertyValue);
                    if (gradient.children[1] !== undefined)
                        gradient.children[1].setAttribute('stop-color', propertyValue);
                }
            }
        } else {
            animationObj.style[propertyName.toLowerCase()] = '';
        }
    } else if (propertyName === 'left') {
        if (propertyValue != undefined && !isNaN(propertyValue)) {
            propertyValue = Number(propertyValue);

            if (animationObj.parentNode.tagName == 'foreignObject') {
                animationObj = animationObj.parentNode;
                AnimationFnc(win, mnemodoc, animationObj, propertyName, propertyValue);
            } else {
                if (!animationObj.hasAttribute('inittanim')) CalcMatrix(animationObj);

                animationObj.transform.baseVal[1].setTranslate(propertyValue, 0);
            }
        }
    } else if (propertyName === 'top') {
        if (propertyValue != undefined && !isNaN(propertyValue)) {
            propertyValue = Number(propertyValue);
            if (animationObj.parentNode.tagName == 'foreignObject') {
                animationObj = animationObj.parentNode;
                AnimationFnc(win, mnemodoc, animationObj, propertyName, propertyValue);
            } else {
                if (!animationObj.hasAttribute('inittanim')) CalcMatrix(animationObj);
                animationObj.transform.baseVal[4].setTranslate(0, propertyValue);
            }
        }
    }
    // else if (propertyName === "levelfill") {

    //     if (propertyValue != undefined && !isNaN(propertyValue)) {
    //         let svgelem = animationObj.ownerSVGElement;

    //         let fillId = (animationObj.style.fill === "") ? animationObj.getAttribute("fill") : animationObj.style.fill;
    //         fillId = fillId.replace("url(", "").replace(")", "").replace(/\"/g, "").replace("#", "");
    //         let gradient = svgelem.getElementById(fillId);

    //         let id = animationObj.dataset.datalinklistid;
    //         let datalinklistElement = svgelem.getElementById(id);

    //         let min: number = 0;
    //         let max: number = 100;

    //         if (datalinklistElement) {
    //             let rows = datalinklistElement.getElementsByTagName("row");

    //             if (rows.length > 0) {
    //                 let firstRowLowLimit = rows[0].getAttribute("lowlimit");
    //                 if (firstRowLowLimit) {
    //                     min = Number(firstRowLowLimit);
    //                 }

    //                 let lastRowHighLimit = rows[rows.length - 1].getAttribute("highlimit");
    //                 if (lastRowHighLimit) {
    //                     max = Number(lastRowHighLimit);
    //                 }
    //             }
    //         }

    //         propertyValue = ((propertyValue - min) / (max - min)) * 100;

    //         if (gradient !== null) {
    //             let stop = gradient.getElementsByTagName("stop");
    //             if (stop.length > 1) {
    //                 stop[1].setAttribute("offset", Number(propertyValue) + "%");
    //             }
    //             if (stop.length > 2) {
    //                 stop[2].setAttribute("offset", Number(propertyValue) + "%");
    //             }

    //         }
    //     }
    // }
    else if (propertyName === 'levelfill') {
        if (propertyValue != undefined && !isNaN(propertyValue)) {
            let fillId = animationObj.style.fill === '' ? animationObj.getAttribute('fill') : animationObj.style.fill;
            fillId = fillId.replace('url(', '').replace(')', '').replace(/\"/g, '').replace('#', '');
            const gradient = mnemodoc.getElementById(fillId);
            if (gradient !== null) {
                let stop = gradient.getElementsByTagName('stop');
                if (stop.length > 1) {
                    stop[1].setAttribute('offset', Number(propertyValue) + '%');
                }
                if (stop.length > 2) {
                    stop[2].setAttribute('offset', Number(propertyValue) + '%');
                }
            }
        } else {
            defaultValue = 30;
            SetDefaultValue(animationObj, propertyName, defaultValue);
        }
    } else if (propertyName === 'opacity') {
        if (propertyValue != undefined && !isNaN(propertyValue) && propertyValue != '') {
            propertyValue = Number(propertyValue);
            if (animationObj.style.opacity != propertyValue.toString()) animationObj.style.opacity = propertyValue;
        } else {
            defaultValue = 1;
            SetDefaultValue(animationObj, propertyName, defaultValue);
        }
    } else if (propertyName === 'fillopacity') {
        if (propertyValue != undefined && !isNaN(propertyValue)) {
            propertyValue = Number(propertyValue);
            if (animationObj.style.fillOpacity != propertyValue.toString())
                animationObj.style.fillOpacity = propertyValue;
        } else {
            defaultValue = 1;
            SetDefaultValue(animationObj, propertyName, defaultValue);
        }
    } else if (propertyName === 'strokeopacity') {
        if (propertyValue != undefined && !isNaN(propertyValue)) {
            propertyValue = Number(propertyValue);
            animationObj.style.strokeOpacity = propertyValue;

            if (animationObj.style.markerStart != '') {
                let idmarker = animationObj.style.markerStart
                    .replace('url(', '')
                    .replace(')', '')
                    .replace(/\"/g, '')
                    .replace('#', '');
                let gradient = mnemodoc.getElementById(idmarker);
                if (gradient !== null) {
                    gradient.firstElementChild.style.strokeOpacity = propertyValue;
                    gradient.firstElementChild.style.fillOpacity = propertyValue;
                }
            }

            if (animationObj.style.markerEnd != '') {
                let idmarker = animationObj.style.markerEnd
                    .replace('url(', '')
                    .replace(')', '')
                    .replace(/\"/g, '')
                    .replace('#', '');
                let gradient = mnemodoc.getElementById(idmarker);
                if (gradient !== null) {
                    gradient.firstElementChild.style.strokeOpacity = propertyValue;
                    gradient.firstElementChild.style.fillOpacity = propertyValue;
                }
            }
        } else {
            defaultValue = 1;
            SetDefaultValue(animationObj, propertyName, defaultValue);
        }
    } else if (propertyName === 'rotation') {
        if (propertyValue != undefined && !isNaN(propertyValue)) {
            propertyValue = Number(propertyValue);

            if (animationObj.parentNode.tagName == 'foreignObject') {
                animationObj = animationObj.parentNode;
                AnimationFnc(win, mnemodoc, animationObj, propertyName, propertyValue);
            } else {
                if (animationObj.style.transformBox == '') {
                    animationObj.style.transformBox = 'fill-box';
                }

                if (animationObj.style.transformOrigin == '' || animationObj.style.transformOrigin == null) {
                    animationObj.style.transformOrigin = '50% 50%';
                }

                if (!animationObj.hasAttribute('inittanim')) CalcMatrix(animationObj);
                animationObj.transform.baseVal[2].setRotate(propertyValue, 0, 0);
            }
        }
    } else if (propertyName === 'visible' || propertyName === 'visibility') {
        if (propertyValue != undefined && !isNaN(propertyValue) && propertyValue !== '') {
            propertyValue = Number(propertyValue);
            if (propertyValue == 0) animationObj.style.visibility = 'hidden';
            else animationObj.style.visibility = '';
        } else {
            if (propertyValue === 'false' || propertyValue === false) animationObj.style.visibility = 'hidden';
            else if (propertyValue === 'true' || propertyValue === true) animationObj.style.visibility = '';
            else animationObj.style.visibility = propertyValue.toString();
        }

        if (animationObj.parentNode.tagName == 'foreignObject') {
            animationObj = animationObj.parentNode;
            AnimationFnc(win, mnemodoc, animationObj, propertyName, propertyValue);
        }
    } else if (propertyName === 'height' || propertyName === 'width') {
        if (!isNaN(propertyValue)) {
            propertyValue = Number(propertyValue);

            if (animationObj.parentNode.tagName == 'foreignObject') {
                animationObj = animationObj.parentNode;
                AnimationFnc(win, mnemodoc, animationObj, propertyName, propertyValue);
            } else {
                // if (animationObj[propertyName.toLowerCase()]) {
                //     animationObj[propertyName.toLowerCase()].baseVal.value = propertyValue;
                // }
                if (animationObj[propertyName.toLowerCase()]) {
                    let svgelem = animationObj.ownerSVGElement;
                    let datalinklistElement = svgelem.getElementById(animationObj.dataset.datalinklistid);
                    propertyName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
                    let datalink = datalinklistElement.querySelector(`[propertyname=${propertyName}]`);
                    let conditionElement = datalink.getElementsByTagName('condition')[0];
                    let position = conditionElement.getAttribute('position');

                    let transform = animationObj.getAttribute('transform');
                    let numbersRegex = /-?\d+(?:\.\d+)?/g;
                    let match = transform.match(numbersRegex);

                    if (propertyName.toLowerCase() === 'height') {
                        let transformYValue = match[match.length - 1];
                        if (position == 'Down') {
                            animationObj[propertyName.toLowerCase()].baseVal.value = propertyValue;
                        } else if (position == 'Up') {
                            let previousHeight = Number(animationObj[propertyName.toLowerCase()].baseVal.value);
                            let newTransformYValue = Number(transformYValue) - (propertyValue - previousHeight);
                            animationObj[propertyName.toLowerCase()].baseVal.value = propertyValue;
                            animationObj.setAttribute(
                                'transform',
                                transform.replace(transformYValue, newTransformYValue)
                            );
                        }
                    }
                    if (propertyName.toLowerCase() === 'width') {
                        let transformXValue = match[match.length - 2];
                        if (position == 'Right') {
                            animationObj[propertyName.toLowerCase()].baseVal.value = propertyValue;
                        } else if (position == 'Left') {
                            let previousWidth = Number(animationObj[propertyName.toLowerCase()].baseVal.value);
                            let newTransformXValue = Number(transformXValue) - (propertyValue - previousWidth);
                            animationObj[propertyName.toLowerCase()].baseVal.value = propertyValue;
                            animationObj.setAttribute(
                                'transform',
                                transform.replace(transformXValue, newTransformXValue)
                            );
                        }
                    }
                } else {
                    let box = animationObj.getBBox();
                    let a = 1,
                        b = 0,
                        c = 0,
                        d = 1,
                        e = 0,
                        f = 0;
                    if (!animationObj.hasAttribute('inittanim')) CalcMatrix(animationObj);
                    if (propertyName.toLowerCase() === 'width') {
                        a = propertyValue / box[propertyName];
                        e = box.x * (1 - a);
                        animationObj.transform.baseVal[3].matrix.a = a;
                        animationObj.transform.baseVal[3].matrix.e = e;
                    } else {
                        d = propertyValue / box[propertyName];
                        f = box[propertyName] * (1 - d) + box.y * (1 - d);
                        animationObj.transform.baseVal[3].matrix.d = d;
                        animationObj.transform.baseVal[3].matrix.f = f;
                    }
                }
            }
        }
    } else if (propertyName === 'title') {
        if (!propertyValue) {
            defaultValue = '';
            SetDefaultValue(animationObj, propertyName, defaultValue);
        }

        if (typeof propertyValue === 'number') {
            if (propertyValue < 0 && propertyValue > -0.01) {
                propertyValue = 0.0;
            }

            if (animationObj.hasAttribute('decimals')) {
                let decimals = animationObj.getAttribute('decimals');
                propertyValue = propertyValue.toFixed(decimals);
            }

            if (animationObj.hasAttribute('numberdigital')) {
                let numberdigital = animationObj.getAttribute('numberdigital');
                if (numberdigital != '0') {
                    if (numberdigital < propertyValue.toString().length && (propertyValue ^ 0) !== propertyValue) {
                        if (numberdigital > propertyValue.toString().indexOf('.')) {
                            let decimals = numberdigital - propertyValue.toString().indexOf('.');
                            propertyValue = Number(propertyValue).toFixed(decimals);
                        } else {
                            numberdigital = propertyValue.toString().indexOf('.');
                            propertyValue = Number(propertyValue.toString().slice(0, numberdigital));
                        }
                    }
                }
            }
        } else {
            if (animationObj.hasAttribute('numberdigital')) {
                let numberdigital = animationObj.getAttribute('numberdigital');
                if (numberdigital != '0') {
                    propertyValue = propertyValue.toString().slice(0, numberdigital);
                }
            }
        }

        if (animationObj.title == undefined) {
            let titleanim;

            if (animationObj.hasChildNodes()) {
                // Таким образом, сначала мы проверям, не пуст ли объект, есть ли у него дети
                let children = animationObj.childNodes;

                for (let i = 0; i < children.length; ++i) {
                    if (children[i].nodeName.toLowerCase() === 'title') {
                        titleanim = children[i];
                    }
                }
            }

            if (titleanim == undefined) {
                titleanim = document.createElementNS('http://www.w3.org/2000/svg', 'title');
                animationObj.appendChild(titleanim);
            }
            titleanim.innerHTML = propertyValue;
        } else {
            animationObj.setAttribute('title', propertyValue);
        }
    }
}

function SetDefaultValue(animObj: any, propertyName: string, value: any) {
    if (animObj.hasAttribute('data-defaultAnim')) {
        let animString = animObj.getAttribute('data-defaultAnim');
        let defaultAnim = JSON.parse(animString);
        let defPropertyValue = defaultAnim[propertyName.toLowerCase()];
        if (!defPropertyValue) {
            defaultAnim[propertyName.toLowerCase()] = value;
            let animString = JSON.stringify(defaultAnim);
            animObj.setAttribute('data-defaultAnim', animString);
        }
    }
}

function CalcMatrix(obj: any) {
    if (!obj.hasAttribute('inittanim')) {
        let alltrans = obj.transform.baseVal;
        let newmatrix = [
            [1, 0, 0],
            [0, 1, 0],
            [0, 0, 1]
        ];
        for (let i = 0; i < alltrans.length; i++) {
            let matrix = alltrans[i].matrix;
            let curmatrix = [
                [matrix.a, matrix.c, matrix.e],
                [matrix.b, matrix.d, matrix.f],
                [0, 0, 1]
            ];
            newmatrix = MultMatrix(newmatrix, curmatrix);
        }
        let newtransform =
            'matrix(' +
            newmatrix[0][0] +
            ',' +
            newmatrix[1][0] +
            ',' +
            newmatrix[0][1] +
            ',' +
            newmatrix[1][1] +
            ',' +
            newmatrix[0][2] +
            ',' +
            newmatrix[1][2] +
            ')';
        newtransform += ' matrix(1,0,0,1,0,0)';
        newtransform += ' matrix(1,0,0,1,0,0)';
        newtransform += ' matrix(1,0,0,1,0,0)';
        newtransform += ' matrix(1,0,0,1,0,0)';
        obj.setAttribute('transform', newtransform);
        obj.setAttribute('inittanim', 'true');
    }
}

function MultMatrix(m1: any, m2: any) {
    let mout = [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0]
    ];
    for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
            for (let inner = 0; inner < 3; inner++) {
                mout[row][col] += m1[row][inner] * m2[inner][col];
            }
        }
    }

    return mout;
}

let SplitStrTag = function (str: string): TxtPos[] {
    let res: TxtPos[] = [];
    let matches = [...str.matchAll(/["|'].*?['|"]|\b([\w]+[\w\-/]+[.][.\w\-]*[\w])/g)];

    matches.forEach((match) => {
        if (!/["'\s()]/.test(match[0]) && match.index != undefined) {
            res.push({ text: match[0], index: match.index });
        }
    });

    return res;

    //return str.split(/\s|\(|\)|==|\!=|\>|\%|\^|\+| - | -|- |\*| \/|\/ | \/ |\[|\]|\===|\=|\{|\}|\<|\|\||\&|&|\||\,|\;/);
};

export let SplitStrFunction = function (str: string): string[] {
    return str.split(/==|\!=|\>|\%|\^|\+| - | -|- |\*| \/|\/ | \/ |\===|\=|\{|\}|\<|\|\||\&|&|\,|\;/);
};

export function ConverStrToCode(str: string) {
    str = str.replace(/this/g, "window['animationObjW']");

    let items = GetItemsStr(str);

    let indexItemOld = 0;
    let indexItemBias = 0;
    for (let i = 0; i < items.length; i++) {
        let txt = items[i].text;
        indexItemOld = items[i].index;

        let replaceMask = "window.GetParam('" + txt + "').V";

        str =
            str.substring(0, indexItemOld + indexItemBias) +
            replaceMask +
            str.substring(indexItemOld + indexItemBias + txt.length);

        indexItemBias = indexItemBias + replaceMask.length - txt.length;
        //str = str.substring(0, indexItemOld) + str.substring(indexItemOld).replace(regEx, replaceMask);
        //indexItemOld = str.indexOf(replaceMask) + replaceMask.length;
    }

    // let l = SplitStrFunction(str);

    let result = { value: str, items: items.map((m) => m.text) };
    return result;
}

export function GetItemsStr(condition: string): TxtPos[] {
    let rez: any = [];
    if (condition != '' && condition != null) {
        rez = SplitStrTag(condition.toUpperCase());

        for (let i = 0; i < rez.length; i++) {
            let isRemove = false;
            if (rez[i].text != '' && rez[i].text != null) {
                let param = window.GetParam(rez[i].text);

                if (param.Q == 0x80330000) {
                    isRemove = true;
                }
            } else {
                isRemove = true;
            }

            if (isRemove) {
                rez.splice(i, 1);
                i--;
            }
        }
    }
    return rez;
}

const isColor = (strColor: string) => {
    const s = new Option().style;
    s.background = strColor;
    return s.background !== '';
};

export async function EvalCommand(command: string, win: any, propertyName: string) {
    let v: any = command;
    let status = true;
    try {
        if (
            propertyName === 'fill' ||
            propertyName === 'stroke' ||
            propertyName === 'color' ||
            propertyName === 'background'
        ) {
            if (isColor(command)) {
                v = command;
                return { v: v, s: status };
            }
        }

        v = await win.eval(command);
        if (v === null) {
            v = 'null';
        } else if (v === undefined) {
            v = '';
        }
    } catch (err) {
        v = 'null';

        status = false;
    }

    if (typeof v == 'string') {
        v = v.toString().replace(/null/g, 'NaN');
    } else if (v == null) {
        v = 'NaN';
    }

    if (!isNaN(v) && v != undefined && v != '') {
        v = Number(v);
    }

    return { v: v, s: status };
}

function compareitem(a: any, b: any) {
    if (a.length > b.length) return -1;
    if (a.length < b.length) return 1;
}

export async function SubItems(items: string[]) {
    await window.SubItems(items);
}

export function UnSubItems(items: string[]) {
    window.UnSubItems(items);
}

let aveanimationtime = 0;

const timeanimation = 1000;
export async function AnimationData(blockTimeout: boolean = false) {
    let startanim = performance.now();

    document.dispatchEvent(windowCycleEvent);

    try {
        await AnimationMnemo(document, window);

        let listmn = HmiFiles.MnemoList;
        if (listmn) {
            for (let ind = 0; ind < listmn.length; ind++) {
                if (listmn[ind].obj.clientHeight === 0) {
                    await HmiFiles.UnSubItem(listmn[ind].framewindow.document);
                } else {
                    if (listmn[ind].obj.hasAttribute('LoadObject')) {
                        let LoadObject = listmn[ind].obj.getAttribute('LoadObject') == 'true' ? true : false;
                        if (LoadObject) await AnimationMnemo(listmn[ind].obj, listmn[ind].framewindow);
                    }
                }
            }
        }
    } catch (ex) {}

    let stopanim = performance.now();
    let timealg = stopanim - startanim;

    let nexttime = timealg < timeanimation ? timeanimation - timealg : 500;
    if (timealg > timeanimation) {
        console.info('animation time = ' + timealg);
    }

    if (!blockTimeout) {
        setTimeout(function () {
            requestAnimationFrame(async () => {
                await AnimationData(false);
            });
        }, nexttime);
    }
}

requestAnimationFrame(async () => {
    await AnimationData(false);
});

let TimeFlickerSec = 500;

function FlickerFnc() {
    let flickerdefault: any = [];
    let t0 = performance.now();

    let flickers: any = [];

    flickers[0] = document.querySelectorAll('[flicker-condition]');

    let listmn = HmiFiles.MnemoList;

    if (listmn) {
        for (let i = 0; i < listmn.length; i++) {
            flickers[i + 1] = listmn[i].obj.querySelectorAll('[flicker-condition]');
        }

        for (let i = 0; i < flickers.length; i++) {
            let flicker = flickers[i];
            flickerdefault[i] = [];
            for (let index = 0; index < flicker.length; index++) {
                let currentanim = flicker[index];

                let flickpro = JSON.parse(currentanim.getAttribute('flicker-condition'));
                flickerdefault[i][index] = {};
                flickerdefault[i][index].element = currentanim;
                flickerdefault[i][index].data = flickpro;

                for (let infli in flickpro) {
                    if (flickpro[infli].enable === true) {
                        let valueToblink = flickpro[infli].value;
                        if (currentanim.style[infli].indexOf('url') === -1) {
                            flickerdefault[i][index].data[infli].normValue = currentanim.style[infli];
                            currentanim.style[infli] = valueToblink;

                            if (currentanim.style.markerStart != '') {
                                let idmarker = currentanim.style.markerStart
                                    .replace('url(', '')
                                    .replace(')', '')
                                    .replace(/\"/g, '')
                                    .replace('#', '');
                                let gradient = listmn[i - 1].obj.querySelector('#' + idmarker);
                                if (gradient !== null) {
                                    gradient.firstElementChild.style.fill = valueToblink;
                                    gradient.firstElementChild.style.stroke = valueToblink;
                                }
                            }

                            if (currentanim.style.markerEnd != '') {
                                let idmarker = currentanim.style.markerEnd
                                    .replace('url(', '')
                                    .replace(')', '')
                                    .replace(/\"/g, '')
                                    .replace('#', '');
                                let gradient = listmn[i - 1].obj.querySelector('#' + idmarker);
                                if (gradient !== null) {
                                    gradient.firstElementChild.style.fill = valueToblink;
                                    gradient.firstElementChild.style.stroke = valueToblink;
                                }
                            }
                        } else {
                            let idgrad = currentanim.style[infli]
                                .replace('url(', '')
                                .replace(')', '')
                                .replace(/\"/g, '')
                                .replace('#', '');
                            let gradient = listmn[i - 1].obj.querySelector('#' + idgrad);
                            if (gradient !== null) {
                                if (gradient.children[0] !== undefined) {
                                    flickerdefault[i][index].data[infli].normValue =
                                        gradient.children[0].getAttribute('stop-color');
                                    gradient.children[0].setAttribute('stop-color', valueToblink);
                                }
                                if (gradient.children[1] !== undefined)
                                    gradient.children[1].setAttribute('stop-color', valueToblink);
                            }
                        }
                    }
                }
            }
        }
        let t1 = performance.now();
        let milsec = t1 - t0;
        let timerez = milsec < TimeFlickerSec && TimeFlickerSec - milsec > 450 ? TimeFlickerSec - milsec : 500;

        let FlickerFncUn = function () {
            let t0 = performance.now();

            for (let i = 0; i < flickerdefault.length; i++) {
                let flicker = flickerdefault[i];
                for (let index = 0; index < flicker.length; index++) {
                    let currentanim = flicker[index].element;

                    let flickpro = flicker[index].data;

                    for (let infli in flickpro) {
                        if (flickpro[infli].enable) {
                            let tempvalue = flickpro[infli].normValue;

                            if (currentanim.style[infli].indexOf('url') === -1) {
                                currentanim.style[infli] = tempvalue;

                                if (currentanim.style.markerStart != '') {
                                    let idmarker = currentanim.style.markerStart
                                        .replace('url(', '')
                                        .replace(')', '')
                                        .replace(/\"/g, '')
                                        .replace('#', '');
                                    let gradient = listmn[i - 1].obj.querySelector('#' + idmarker);
                                    if (gradient !== null) {
                                        gradient.firstElementChild.style.fill = tempvalue;
                                        gradient.firstElementChild.style.stroke = tempvalue;
                                    }
                                }

                                if (currentanim.style.markerEnd != '') {
                                    let idmarker = currentanim.style.markerEnd
                                        .replace('url(', '')
                                        .replace(')', '')
                                        .replace(/\"/g, '')
                                        .replace('#', '');
                                    let gradient = listmn[i - 1].obj.querySelector('#' + idmarker);
                                    if (gradient !== null) {
                                        gradient.firstElementChild.style.fill = tempvalue;
                                        gradient.firstElementChild.style.stroke = tempvalue;
                                    }
                                }
                            } else {
                                let idgrad = currentanim.style[infli]
                                    .replace('url(', '')
                                    .replace(')', '')
                                    .replace(/\"/g, '')
                                    .replace('#', '');
                                let gradient = listmn[i - 1].obj.querySelector('#' + idgrad);
                                if (gradient !== null) {
                                    if (gradient.children[0] !== undefined)
                                        gradient.children[0].setAttribute('stop-color', tempvalue);
                                    if (gradient.children[1] !== undefined)
                                        gradient.children[1].setAttribute('stop-color', tempvalue);
                                }
                            }
                        }
                    }
                }
            }
            let t1 = performance.now();
            let milsec = t1 - t0;
            let timerez = milsec < TimeFlickerSec && TimeFlickerSec - milsec > 450 ? TimeFlickerSec - milsec : 500;

            setTimeout(function () {
                requestAnimationFrame(FlickerFnc);
            }, timerez);
        };

        setTimeout(function () {
            requestAnimationFrame(FlickerFncUn);
        }, timerez);
    } else {
        setTimeout(function () {
            requestAnimationFrame(FlickerFnc);
        }, TimeFlickerSec);
    }
}
requestAnimationFrame(FlickerFnc);
